const symbols = {
    snap_pt: {
        // 默认捕捉图标
        type: 'CompositeMarkerSymbol',
        symbols: [
            {
                type: 'CrossMarkerSymbol',
                size: 40,
                color: 'blue',
            },
            {
                type: 'CircleMarkerSymbol',
                radius: 4,
                color: 'blue',
            },
        ],
    },
    snap_pt_vector: {
        // 默认捕捉图标
        type: 'CompositeMarkerSymbol',
        symbols: [
            {
                type: 'CrossMarkerSymbol',
                size: 40,
                color: 'red',
            },
            {
                type: 'CircleMarkerSymbol',
                radius: 4,
                color: 'red',
            },
        ],
    },
    snap_pt_outline: {
        // 默认捕捉图标
        type: 'CompositeMarkerSymbol',
        symbols: [
            {
                type: 'CrossMarkerSymbol',
                size: 40,
                color: 'green',
            },
            {
                type: 'CircleMarkerSymbol',
                radius: 4,
                color: 'green',
            },
        ],
    },
    snap_pt_vertex: {
        // 形状点捕捉图标
        type: 'CircleMarkerSymbol',
        radius: 2,
        color: 'blue',
    },
    snap_box: {
        // 捕捉矩形框图标
        type: 'SimpleFillSymbol',
        color: 'blue',
        opacity: 0.5,
        outLine: {
            type: 'SimpleLineSymbol',
            color: 'blue',
            width: 1,
        },
    },
    drag_region: {
        // 鼠标拖拽拉框图标
        type: 'SimpleFillSymbol',
        opacity: 0,
        outLine: {
            type: 'SimpleLineSymbol',
            style: 'dot',
            color: 'black',
            width: 1,
        },
    },
    mouse_msg_info: {
        type: 'TextMarkerSymbol',
        color: 'blue',
        font: '微软雅黑',
        size: 14,
        offsetY: 30, // 保证文字在鼠标下方不被鼠标遮盖
    },
    mouse_msg_warn: {
        type: 'TextMarkerSymbol',
        color: 'brown',
        font: '微软雅黑',
        size: 14,
        offsetY: 30,
    },
    mouse_msg_error: {
        type: 'TextMarkerSymbol',
        color: 'red',
        font: '微软雅黑',
        size: 14,
        offsetY: 30,
    },
    center_msg_info: {
        type: 'TextMarkerSymbol',
        color: 'blue',
        font: '微软雅黑',
        size: 14,
    },
    center_msg_warn: {
        type: 'TextMarkerSymbol',
        color: 'brown',
        font: '微软雅黑',
        size: 14,
    },
    center_msg_error: {
        type: 'TextMarkerSymbol',
        color: 'red',
        font: '微软雅黑',
        size: 14,
    },
    selected_pt: {
        type: 'CircleMarkerSymbol',
        radius: 4,
        color: 'red'
    },
    selected_ls: {
        type: 'SimpleLineSymbol',
        width: 2,
        color: 'red'
    },
    selected_pg: {
        type: 'SimpleFillSymbol',
        opacity: 0,
        color: '#FF0A0E',
        outLine: {
            type: 'SimpleLineSymbol',
            width: 1,
            color: '#FF0A0E'
        }
    },
    hover_pt: {
        type: 'CircleMarkerSymbol',
        radius: 4,
        color: 'blue'
    },
    hover_ls: {
        type: 'SimpleLineSymbol',
        width: 2,
        color: 'blue'
    },
    hover_pg: {
        type: 'SimpleFillSymbol',
        opacity: 0.5,
        color: 'blue',
        outLine: {
            type: 'SimpleLineSymbol',
            width: 2,
            color: 'blue'
        }
    },
};

export default function getSymbol(key) {
    return symbols[key];
}
